module.exports = __webpack_public_path__ + "img/horizontal_7_6_5010.475f0e06.png";